import { httpClient, ApiResponse } from '@/utils';
import {
  GenerateQrEndpoints,
  IGeneratedQrListDTO,
  IGeneratedQrListResponse,
  ICreateProductsQrDTO,
} from '@/models/generateQr.model';

class GeneratedQrAPI {
  static getGeneratedQrList(data: IGeneratedQrListDTO): ApiResponse<IGeneratedQrListResponse> {
    return httpClient.get<IGeneratedQrListResponse>(GenerateQrEndpoints.GET_PRODUCTS_QR, {
      params: data,
    });
  }

  static createProductsQrList(data: ICreateProductsQrDTO) {
    return httpClient.post(GenerateQrEndpoints.GET_PRODUCTS_QR, data);
  }
}

export default GeneratedQrAPI;
